export const CREATE_LANDING_REQUEST = 'CREATE_LANDING_REQUEST';
export const CREATE_LANDING_SUCCESS = 'CREATE_LANDING_SUCCESS';
export const CREATE_LANDING_FAILED = 'CREATE_LANDING_FAILED';
